import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@feathr/components';
import ErrorPage from '@feathr/extender/App/ErrorPage';
import { useLocalUrl } from '@feathr/extender/state';

function OnboardingIncomplete(): JSX.Element {
  const localUrl = useLocalUrl();
  const { t } = useTranslation();

  const description = t('Please complete the onboarding process to access the dashboard.');

  return (
    <ErrorPage description={description} title={t('Onboarding not complete')}>
      <Button link={localUrl('/quickstart')} type={'primary'}>
        {t('Continue onboarding')}
      </Button>
    </ErrorPage>
  );
}

export default observer(OnboardingIncomplete);
